export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          联系我们
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">
          欢迎反馈意见、推荐剧集或商业合作
        </p>
        <div className="max-w-lg mx-auto bg-background-50 rounded-xl p-6 md:p-8 border border-background-200/60">
          <div className="space-y-5">
            <div className="flex items-center gap-4">
              <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center shrink-0">
                <i className="ri-mail-line text-xl text-accent-600"></i>
              </div>
              <div>
                <p className="text-sm font-medium text-foreground-900">电子邮箱</p>
                <p className="text-sm text-foreground-600">contact@laoziys.com</p>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center shrink-0">
                <i className="ri-chat-3-line text-xl text-primary-600"></i>
              </div>
              <div>
                <p className="text-sm font-medium text-foreground-900">意见反馈</p>
                <p className="text-sm text-foreground-600">欢迎通过邮箱提交电视剧推荐或使用反馈</p>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center shrink-0">
                <i className="ri-briefcase-line text-xl text-accent-600"></i>
              </div>
              <div>
                <p className="text-sm font-medium text-foreground-900">商务合作</p>
                <p className="text-sm text-foreground-600">广告投放与商务合作咨询请发送邮件</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}